import { createFileRoute } from '@tanstack/react-router';

import { ErrorLayout } from '@/components/ErrorLayout';

export const Route = createFileRoute('/error/500')({
  component: RouteComponent,
});

export function RouteComponent() {
  return (
    <ErrorLayout
      code="500"
      title="Erreur interne"
      description="Une erreur interne est survenue sur le serveur. Nos équipes ont été notifiées."
      image="/assets/images/error-500.png"
      cta={{ label: "Retour à la page d'accueil", to: '/' }}
    />
  );
}
